module.exports = __webpack_public_path__ + "img/cybersecurity.08561d97.svg";